/**
 * UI模块，负责和页面变化有关的一些方法和组件
 *
 * @author mingxin.huang
 * @update 2014.11.04
 *
 * 公用方法
 *
 * openWindow : 打开新窗口,
 * fixPng     : 修复IE6下的png图片bug,
 * insertSWF  : 插入SWF文件方法,
 * manuRender : 渲染页面方法,
 * autoRender : 需请求接口渲染页面方法
 *
 */

$.module('MM.ui.base', function () {
  /**
   * 打开新窗口
   * @param  {String} url    url地址
   * @param  {Number} width  窗口宽度
   * @param  {Number} height 窗口高度
   */
  function _openWindow(url, width, height) {
    var target = '_blank';

    if (width > 0 && height > 0) {
      var top = (window.screen.height - height) / 2,
        left = (window.screen.width - width) / 2;
      return window.open(
        url,
        'detail',
        'height=' +
          height +
          ', width=' +
          width +
          ', top=' +
          top +
          ',left=' +
          left +
          ', toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no',
      );
    } else {
      return window.open(url, target);
    }
  }

  /**
   * 插入播放器
   * @param url  播放器地址
   * @param params
   * params :{
   *      domId :flash DOM容器元素 ID
   *      roomId: 房间ID
   *      width: 默认100%
   *      height: 默认100%
   *
   *      以下参数为主播身份可传
   *      mute: [0,1]  是否默认静音  默认:0
   *      starId: 主播Id
   *      line: 线路ID  [1:网宿，3:Ucloud]
   *      bg: 背景图片
   * }
   * @private
   */
  function _insertSWFPlayer(url, params, flashvars) {
    var defaultParams = {
      domId: '',
      width: '100%',
      height: '100%',
    };
    var defaultFlashvars = {
      roomId: '',
      mute: 0,
      starId: '',
      line: 1,
      userId: MM.user.getUserId(),
      env: MM.config.isRelease() ? 'production' : 'develop',
    };
    var falshParams = {
      quality: 'high',
      allowscriptaccess: 'always',
      allowfullscreen: 'true',
      wmode: 'transparent',
      menu: 'false',
      scale: 'noScale',
    };
    var attr = {
      id: params.domId,
      name: params.domId,
      align: 'middle',
    };
    var version = '9';

    flashvars = $.extend(defaultFlashvars, flashvars);
    params = $.extend(defaultParams, params, { flashvars: $.param(flashvars) });

    //'?roomId={roomId}&env={env}&mute={mute}'
    // url += "?" + $.param(params);

    swfobject.embedSWF(
      url,
      params.domId,
      params.width,
      params.height,
      version,
      '',
      {},
      $.extend({}, falshParams, params),
      attr,
    );
  }

  /**
   * 插入SWF文件方法
   * @param  {String}  url       swf文件地址
   * @param  {String}  id        对应的在页面中的ID
   * @param  {Number} width 宽度
   * @param  {Number} height 高度
   * @param  {Functiion} isReady 用以判别是否已经加载成功的方法
   * @param  {Function}  success   成功的回调函数
   * @param  {Function}  overTime   超时的回调函数
   */
  function _insertSWF(
    url,
    id,
    width,
    height,
    isReady,
    success,
    overTime,
    flashvars,
  ) {
    var params = {
        quality: 'high',
        allowscriptaccess: 'always',
        allowfullscreen: 'false',
        wmode: 'transparent',
      },
      attr = {
        id: id,
        name: id,
        align: 'middle',
      },
      version = '9';

    if (flashvars) {
      params.flashvars = $.param(flashvars);
    }

    swfobject.embedSWF(
      url,
      id,
      width,
      height,
      version,
      '',
      {},
      params,
      attr,
      function (e) {
        if (!$.isFunction(isReady) || !$.isFunction(success)) {
          return;
        }

        var _loadCount = 0;
        var _loadIntervalId = setInterval(function () {
          _loadCount++;

          var tempSwf = swfobject.getObjectById(id);

          if (isReady(tempSwf)) {
            success(tempSwf);

            clearInterval(_loadIntervalId);
          }

          if (_loadCount > 20) {
            if ($.isFunction(overTime)) {
              overTime();
            }
            clearInterval(_loadIntervalId);
          }
        }, 300);
      },
    );
  }

  /**
   * 渲染页面方法
   * @param  {JQuery} selector     jq对象
   * @param  {String} template     模板
   * @param  {Object} data         填充数据
   * @param  {String} appendMethod 填充方法默认html
   * @return {JQuery}              jq对象
   */
  function _manuRender(selector, template, data, appendMethod) {
    var $selector = typeof selector == 'string' ? $(selector) : selector,
      html = '';

    if (!$selector || !$selector.hasClass) {
      return;
    }

    html = data
      ? $.template(template, {
          data: data,
        })
      : template;

    appendMethod = typeof appendMethod == 'string' ? appendMethod : 'html';
    $selector[appendMethod](html);

    return $selector;
  }

  /**
   * 需请求接口渲染页面方法
   * @param  {Object} params 基本参数和MM.core.getResult相同，额外参数为本方法独有
   * {
   * 	url             : {String} 请求地址
   *  type            : {POST/GET} 请求方式
   *  disableProxy    : {Boolean} 是否使用代理
   *  data            : {Object} 请求发送参数
   *  requireToken    : {Boolean} 是否需要access_token
   *  success         : {Function} 成功的回调函数
   *  error           : {Function} 失败的回调函数
   *  resolveError    : {Function} 处理业务错误的回调函数
   *
   *  selector        : {JQuery} jq对象
   *  template        : {String} 模板
   *  appendMethod    : {String} 填充方法默认html
   *  successCallback : {Function} 插入成功后的回调函数
   * }
   */
  function _autoRender(params) {
    params.success = function (res) {
      res.params = params;

      var $tempSelector = _manuRender(
        params.selector,
        params.template,
        res,
        params.appendMethod,
      );

      if ($.isFunction(params.successCallback)) {
        params.successCallback($tempSelector, res);
      }
    };
    MM.core.getResult(params);
  }

  /**
   * 控制页面滚动条的位置
   * @param top
   */
  function _scrollTop(top) {
    var $body = window.opera
      ? document.compatMode == 'CSS1Compat'
        ? $('html')
        : $('body')
      : $('html,body');

    $body.animate({
      scrollTop: top || 0,
    });
  }

  return {
    openWindow: _openWindow,
    insertSWF: _insertSWF,
    insertSWFPlayer: _insertSWFPlayer,
    manuRender: _manuRender,
    autoRender: _autoRender,
    scrollTop: _scrollTop,
  };
});
